module.exports = __webpack_public_path__ + "front/img/logo2.907b98d4.png";